<script>
import useValidation from "@/use/Validation";
import useTools from "@/use/Tools";
import useSharedMethod from "@/use/SharedMethod";
import useSharedData from "@/use/SharedData";
import {ref} from "vue";
import StrOutStateModelAutocomplete from "@/views/OutStateModel/Components/StrOutStateModelAutocomplete.vue";
import axios from "axios";

export default {
    components: {StrOutStateModelAutocomplete},
    setup() {
        const {mxRules} = useValidation();
        const {$refs, $route} = useTools();
        const {getBack} = useSharedMethod();
        const {dialog, loading} = useSharedData();

        const modelId = ref(null);

        function print() {
            if ($refs.form.validate()) {
                loading.value = true;
                axios.post(`/printed/vacationTitle/${$route.params.id}/${modelId.value}`, null, {
                    responseType: "blob",
                }).then((response) => {
                    const blob = response.data;
                    const link = document.createElement("a");
                    link.href = window.URL.createObjectURL(blob);
                    window.open(link, "_blank");
                    getBack();
                }).finally(() => {
                    loading.value = false;
                });
            }
        }

        return {
            mxRules,
            dialog,
            loading,
            modelId,
            getBack,
            print
        }
    }
}
</script>

<template>
    <v-dialog
        v-model="dialog"
        persistent
        max-width="500"
        scrollable
    >
        <v-card>
            <w-toolbar color="teal" :title="$t('absence_request.vacation_title')"/>
            <v-card-text>
                <v-container fluid>
                    <v-form ref="form" lazy-validation>
                        <v-row dense>
                            <v-col cols="12">
                                <w-label label="Modèle" required/>
                                <str-out-state-model-autocomplete
                                    v-model="modelId"
                                    type="VACATION_TITLE"
                                    :rules="[mxRules.required]"
                                />
                            </v-col>
                        </v-row>
                    </v-form>
                </v-container>
            </v-card-text>
            <v-divider/>
            <v-card-actions>
                <v-spacer/>
                <w-btn-close @press="getBack"/>
                <w-btn
                    color="teal"
                    icon="mdi-cloud-print"
                    :text="$t('common.print')"
                    :loading="loading"
                    @press="print"
                />
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>